<template>
  <b-modal
    v-model="showModal"
    ref="formEquipments"
    centered
    hide-header
    hide-footer
    size="sm"
  >
    <h6>{{ typeName }}</h6>
    <b-input
      @input="(search) => searchFilter(equipments, search)"
      type="text"
      placeholder="Buscar"
      autocomplete="off"
      class="form-control form-control-sm"
    />

    <div class="equipment-table">
      <div v-if="loadingLogOptions" class="col-xs-12 center-xs w-100 mt-2">
        <spinner />
        <span> Aguarde...</span>
      </div>

      <b-table
        v-if="!loadingLogOptions"
        striped
        small
        borderless
        hover
        responsive
        :items="eqpsTable"
        :fields="fields"
      >
        <template slot="HEAD_CHECK">
          <b-form-checkbox
            v-if="selectType == 'selectCheckBox'"
            @click.native.prevent="toggleAll()"
            v-model="allSelected"
          />
          <span v-if="selectType == 'selectRadio'" :disabled="true" />
        </template>

        <template slot="CHECK" slot-scope="row">
          <b-form-checkbox
            v-if="selectType == 'selectCheckBox'"
            :value="row.item"
            v-model="innerSelected"
          />
          <b-form-radio
            v-if="selectType == 'selectRadio'"
            :value="row.item"
            v-model="innerSelected"
          />
        </template>

        <template slot="NAME" slot-scope="row">
          {{ row.item.NAME }}
        </template>
      </b-table>
    </div>
    <b-btn block size="sm" @click="$refs.formEquipments.hide()">Voltar</b-btn>
  </b-modal>
</template>

<script>
export default {
  props: {
    equipments: {
      type: Array,
      required: true,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    selected: {
      required: false,
      type: [Array, Object],
    },
    actuatorFilters: {
      required: false,
      type: Array,
      default: () => [],
    },
    elementsType: {
      type: String,
      required: false,
      default: "",
    },
    typeName: {
      type: String,
      required: false,
      default: "",
    },
    selectType: {
      type: String,
      required: false,
      default: "",
    },
    equipmentsHandle: {
      required: true,
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isFiltered: false,
      filteredElements: [],
      innerSelected: [],
      allSelected: false,
      loadingLogOptions: false,
      initialFilter: {
        title: "Todos",
        value: 1,
      },
      currentSettedFilter: null,
    };
  },
  methods: {
    searchFilter(allElements, type) {
      this.isFiltered = !!type.split(" ").join("");
      const searchLower = type.toLowerCase();
      this.filteredElements = allElements.filter(
        (item) => item.NAME.toLowerCase().indexOf(searchLower) > -1
      );
    },
    toggleAll() {
      this.allSelected = !this.allSelected;

      if (this.allSelected) {
        this.innerSelected = this.equipments;
      } else {
        this.innerSelected = [];
      }
    },
  },
  computed: {
    eqpsTable() {
      if (this.isFiltered) {
        return this.filteredElements;
      }
      return this.equipments;
    },
    showingFilters() {
      return [this.initialFilter, ...this.equipmentsHandle.filters];
    },
    fields() {
      const commonField = {
        key: "CHECK",
        label: "",
        tdClass: "selector-class col-xs-2 col-md-1",
        thClass: "selector-class col-xs-2 col-md-1",
      };

      const nameField = {
        label:
          this.selectType === "selectCheckBox"
            ? this.equipments.length + " opções"
            : "",
        key: "NAME",
        tdClass: "name-class",
        thClass: "name-class",
      };
      return [commonField, nameField];
    },
    currentFilter() {
      return this.currentSettedFilter
        ? this.currentSettedFilter
        : this.initialFilter;
    },
    showModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    innerSelected: {
      handler(newValue) {
        // console.log(newValue);
        if (newValue) {
          this.$emit("selected", newValue, this.elementsType);
        }
      },
    },
  },
  async created() {
    this.innerSelected = this.selected;
    this.loadingLogOptions = true;
    this.loadingLogOptions = false;
    // this.currentSettedFilter = this.actuatorFilters[0];
  },
};
</script>

<style scoped>
::v-deep .minha-classe {
}
::v-deep .name-class {
  max-width: 40px !important;
}
.pick-equipments-modal :deep > ul {
  width: 100% !important;
}
.pick-equipments-modal :deep > button {
  font-size: 15px !important;
}

.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
